import React from 'react';
import PropTypes from 'prop-types';
import SchoolImageSelect from './schoolImageSelect';
import CourseImageSelect from './courseImageSelect';
import localStyles from './styles.less';

const CourseSchoolImage = ({
  imageSchool,
  schoolTitle,
  email,
  phone,
  setValue,
  schoolHint,
  schoolHeader,
  courseHeader,
  courseImage,
  imageButtonText,
  courseImageHint,
  t,
}) => (
  <div className={localStyles.container}>
    <SchoolImageSelect
      image={imageSchool}
      schoolTitle={schoolTitle}
      email={email}
      phone={phone}
      setValue={setValue}
      hint={schoolHint}
      title={schoolHeader}
      t={t}
    />
    <CourseImageSelect
      image={courseImage}
      imageButtonText={imageButtonText}
      hint={courseImageHint}
      setValue={setValue}
      title={courseHeader}
      t={t}
    />
  </div>
);

CourseSchoolImage.propTypes = {
  imageSchool: PropTypes.string,
  schoolHint: PropTypes.string,
  courseImage: PropTypes.string,
  imageButtonText: PropTypes.string,
  courseImageHint: PropTypes.string,
  schoolHeader: PropTypes.string,
  courseHeader: PropTypes.string,
  schoolTitle: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.any,
  setValue: PropTypes.func,
  t: PropTypes.func,
};

CourseSchoolImage.defaultProps = {
  imageSchool: '',
  schoolHint: '',
  courseImage: '',
  imageButtonText: '',
  courseImageHint: '',
  schoolHeader: '',
  courseHeader: '',
  schoolTitle: '',
  email: '',
  phone: '',
  setValue: () => {},
  t: () => {},
};

export default CourseSchoolImage;
